module.exports = __webpack_public_path__ + "static/media/mark-casual-2.841027f1.jpg";